import { BKJIcon } from '@bookjane2/bookjane-design-library';
import { elementDimensions } from 'constants/elementDimensions';
import { zIndexLayers } from 'constants/zIndexLayers';
import { Ref } from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

const {
  DesktopPageHeaderHeight,
  MobilePageHeaderHeight,
  OpenSettingsNavigationWidth,
  ClosedSettingsNavigationWidth,
  SetupBanner,
} = elementDimensions;

interface ReportsNavWrapper {
  ref?: Ref<HTMLDivElement>;
  $isOpen: boolean;
  id: string;
  isPendingApproval: boolean;
}

export const ReportsNavigationWrapper = styled.div<ReportsNavWrapper>`
  ${({ $isOpen, theme, isPendingApproval }) => {
    return css`
      z-index: ${zIndexLayers.settingsNavigation};
      position: fixed;
      top: ${DesktopPageHeaderHeight + (isPendingApproval ? SetupBanner : 0)}px;
      bottom: 0;
      left: 80px;
      background-color: ${theme.colors.Grey1};
      min-width: ${$isOpen ? OpenSettingsNavigationWidth : ClosedSettingsNavigationWidth}px;
      width: ${$isOpen ? OpenSettingsNavigationWidth : ClosedSettingsNavigationWidth}px;
      transition: width 0.3s ease-in-out;
      @media (max-width: ${theme.breakpoints.Tablet}) {
        top: ${MobilePageHeaderHeight}px;
        left: 0;
      }
      ${theme.shadows.Default};
    `;
  }}
`;

export const ReportsNavItemWrapper = styled.div<{ $isOpen: boolean }>`
  min-height: 57px;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  background-color: transparent;
  transition: opacity 0.3s ease-in-out;
  display: flex;
  align-items: center;
`;

export const ReportsNavItem = styled.div<{ $isComingSoon?: boolean }>`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  ${({ theme }) => theme.typography.Caption};
  font-weight: 400;
  color: ${({ theme, $isComingSoon }) =>
    $isComingSoon ? theme.colors.Grey6 : theme.colors.TextDarkGrey};
  gap: 12px;
  transition: all 0.2s ease-in-out;
`;

export const ReportsNavTextColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ReportsNavSubLabel = styled.span`
  display: block;
  font-size: 11px;
  font-weight: 400;
  line-height: 1.3;
  margin-top: 2px;
  color: ${({ theme }) => theme.colors.Grey6};
`;

export const ReportsInternalMenuLink = styled(Link)<{ $isActive?: boolean; $isOpen?: boolean }>`
  display: block;
  pointer-events: ${({ $isOpen }) => ($isOpen === false ? 'none' : 'auto')};
  border-top: 1px solid ${({ theme }) => theme.colors.Grey5};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  text-decoration: none;
  transition: all 0.2s ease-in-out;

  ${ReportsNavItemWrapper} {
    background-color: ${({ theme }) => theme.colors.Grey1};
  }

  &:hover {
    ${({ $isActive }) =>
      !$isActive &&
      css`
        ${ReportsNavItemWrapper} {
          background-color: ${({ theme }) => theme.colors.Grey2};
        }
      `}
  }

  &:hover {
    ${({ $isActive }) =>
      $isActive &&
      css`
        ${ReportsNavItemWrapper} {
          background-color: ${({ theme }) => theme.colors.PrimaryHover};
        }
      `}
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      ${ReportsNavItemWrapper} {
        background-color: ${({ theme }) => theme.colors.PrimaryDefault};
      }
      ${ReportsNavItem} {
        color: ${({ theme }) => theme.colors.White};
      }
      ${ReportsNavSubLabel} {
        color: ${({ theme }) => theme.colors.White};
      }
    `}

  &:first-child {
    border-top: none !important;
  }
  &:last-child {
    border-bottom: 1px solid ${({ theme }) => theme.colors.Grey5};
  }
`;

interface IToggleReportsNavIcon {
  $isOpen: boolean;
}

export const ToggleReportsNavIcon = styled(BKJIcon)<IToggleReportsNavIcon>`
  background-color: white;
  box-shadow: 0px 2px 8px 0px #0d33204d;
  border-radius: 50%;
  position: absolute;
  cursor: pointer;
  top: 56px;
  right: -8px;
  transition: left 200ms ease-in-out, right 200ms ease-in-out;
  z-index: ${zIndexLayers.settingsNavigation};
`;
